var render, staticRenderFns
import script from "./woven.vue?vue&type=script&lang=js"
export * from "./woven.vue?vue&type=script&lang=js"
import style0 from "./woven.vue?vue&type=style&index=0&id=7067536b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7067536b",
  null
  
)

export default component.exports